module.exports = __webpack_public_path__ + "img/hello_exit.14616dbc.png";